export default __webpack_public_path__ + "static/media/no_valido.6ace82b4.svg";